import React from 'react';
import { Link } from 'react-router-dom';
import ErrorLayout from '../components/ErrorLayout';

const Error503 = () => {
  return (
    <ErrorLayout
      code={503}
      title="Service Unavailable"
      message="Sunucu bakımda veya aşırı yoğun. Lütfen kısa bir süre sonra tekrar dene."
      action={<Link to="/" className="px-4 py-2 rounded-lg text-white" style={{ backgroundColor: '#1E40AF' }}>Ana sayfaya dön</Link>}
    />
  );
};

export default Error503;


